import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Vital options array using correct paths from Routes.js
const vitalOptions = [
  {
    key: "bloodpressure",
    label: "Blood Pressure",
    icon: "monitor_heart",
    to: "/admin/patientmanagement/vitals/bloodpressure",
  },
  {
    key: "temperature",
    label: "Temperature",
    icon: "device_thermostat",
    to: "/admin/patientmanagement/vitals/temperature",
  },
  {
    key: "heartrate",
    label: "Heart Rate",
    icon: "favorite",
    to: "/admin/patientmanagement/vitals/heartrate",
  },
  {
    key: "respirationrate",
    label: "Respiration Rate",
    icon: "air",
    to: "/admin/patientmanagement/vitals/respirationrate",
  },
  {
    key: "oxygensaturation",
    label: "Oxygen Saturation",
    icon: "bloodtype",
    to: "/admin/patientmanagement/vitals/oxygensaturation",
  },
  {
    key: "height",
    label: "Height",
    icon: "height",
    to: "/admin/patientmanagement/vitals/height",
  },
  {
    key: "headcircumference",
    label: "Head Circumference",
    icon: "circle",
    to: "/admin/patientmanagement/vitals/headcircumference",
  },
  {
    key: "weight",
    label: "Weight",
    icon: "scale",
    to: "/admin/patientmanagement/vitals/weight",
  },
];

const VitalCommonheader = ({ activeOption = "" }) => {
  const { t } = useTranslation(); //for translation

  return (
    <ul
      className="nav nav-tabs d-inline-flex p-1 body-bg flex-nowrap fs-md lh-1 fw-semibold border-0 text-nowrap rounded-10 overflow-auto mb-2"
      id="mailTab"
    >
      {vitalOptions.map((option) => (
        <li className="nav-item" role="presentation" key={option.key}>
          <Link
            to={option.to}
            className={`text-black d-flex align-items-center justify-content-center gap-2 rounded-10${
              activeOption === option.key ? " active" : ""
            }`}
          >
            <span className="d-block material-symbols-outlined icon-lg">
              {option.icon}
            </span>
            <span className="d-block">{t(option.label)}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default VitalCommonheader;
